







































































































































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import { AccountCertificate, AccountCertificateType } from '@/modules/AccountCertificate/interfaces/account-certificate'
import AccountPropertyDialog from '@/modules/AccountCertificate/scripts/account-certificate-dialog'
import { dateToDisplay } from '@/utils/dateTime'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard
  }
})
export default class AccountCertificateDetailDetail extends mixins(AccountPropertyDialog) {
  @Prop({ type: Object as () => AccountCertificate }) readonly accountCertificate!: AccountCertificate

  dateToDisplay = dateToDisplay
  AccountCertificateType = AccountCertificateType

  get notes () {
    if (!this.accountCertificate) return []
    return this.accountCertificate.notes.split('\n')
  }
}
